import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import SwitchDateTermsLink from './components/SwitchDateTermsLink';
import SwitchDateTermsSwitch from './components/SwitchDateTermsSwitch';
import SwitchDateTermsAgree from './components/SwitchDateTermsAgree';
import DateComponent from './components/DateComponent';
import { validateSwitchDate } from './utils/dateUtils';
import { renderCardError } from '../../utils/cardsError';

class SwitchDatePage extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedDate: '', validationType: '', isPristine: false };
    this.onDateChange = this.onDateChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onDateChange(date) {
    this.setState({
      ...this.state,
      selectedDate: date,
      validationType: validateSwitchDate(date)
    });
  }

  onSubmit() {
    this.setState({ ...this.state, isPristine: true });
  }

  render() {
    const {
      saveSwitchDateForm,
      getBusinessData,
      isCurrentAccountSwitch,
      isSoleTrader,
      switchDateTermsLinkHref,
      switchDateError
    } = this.props;
    return (
      <Form
        onSubmit={values => {
          if (
            (this.state.validationType && this.state.validationType !== 'required') ||
            !isCurrentAccountSwitch
          ) {
            saveSwitchDateForm(values, isSoleTrader, this.state.selectedDate);
          }
        }}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({
                switchDatePageTitle = '',
                switchDatePageText = '',
                switchDateHelpText = '',
                submitButtonText = '',
                switchDateOnLabel = '',
                paymentTransferSwitchText1 = '',
                paymentTransferSwitchText2 = ''
              }) => (
                <div>
                  {isCurrentAccountSwitch && (
                    <div>
                      <PageHeading>{switchDatePageTitle}</PageHeading>
                      <StandardBody>
                        <p>{switchDatePageText}</p>
                      </StandardBody>

                      <GenericFieldWrapper
                        inputId="switchDateSwitch"
                        title={switchDateOnLabel}
                        description={switchDateHelpText}
                      >
                        <DateComponent
                          onDateChange={this.onDateChange}
                          selectedDate={this.state.selectedDate}
                          isPristine={this.state.isPristine}
                          validationType={this.state.validationType}
                        />
                      </GenericFieldWrapper>
                      <SwitchDateTermsLink
                        isCurrentAccountSwitch={isCurrentAccountSwitch}
                        switchDateTermsLinkHref={switchDateTermsLinkHref}
                      />

                      <SwitchDateTermsSwitch values={values} />
                    </div>
                  )}
                  {!isCurrentAccountSwitch && (
                    <div>
                      <PageHeading>{switchDatePageTitle}</PageHeading>
                      <StandardBody>
                        <p>{paymentTransferSwitchText1}</p>
                        <p>{paymentTransferSwitchText2}</p>
                      </StandardBody>

                      <SwitchDateTermsLink
                        isCurrentAccountSwitch={isCurrentAccountSwitch}
                        switchDateTermsLinkHref={switchDateTermsLinkHref}
                      />
                    </div>
                  )}
                  <SwitchDateTermsAgree values={values} />
                  {switchDateError ? renderCardError(switchDateError) : ''}

                  <Submit hideExit onClick={this.onSubmit} submitButtonText={submitButtonText} />
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
SwitchDatePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveSwitchDateForm: PropTypes.func.isRequired
};

export default SwitchDatePage;
